// extracted by mini-css-extract-plugin
module.exports = {"cookie-verbiage":"CookieConsent_cookie-verbiage__3SGDu","cookie-consent-wrapper":"CookieConsent_cookie-consent-wrapper__3Il6A","cookie-header":"CookieConsent_cookie-header__125Ua"};